import React, { Component } from 'react'

import classNames from './GenericIncludeExcludePicker.css'

export default class GenericIncludeExcludePicker extends Component {
  selectItem = e => {
    const { value, onChange } = this.props
    onChange(value.concat({ value: e.target.value, operator: 'should' }))
  }
  excludeItem = e => {
    const { value, onChange } = this.props
    const index = value.findIndex(t => t.value === e.target.value)
    const newValue = value.slice(0)
    newValue[index].operator = 'must_not'
    onChange(newValue)
  }
  removeItem = e => {
    const { value, onChange } = this.props
    if (value.length === 1) {
      onChange(undefined)
      return
    }
    onChange(value.filter(t => t.value !== e.target.value))
  }
  isValue (key, operator) {
    return this.props.value.findIndex(t => t.value === key && t.operator === operator) !== -1
  }
  renderOption = option => {
    const selected = this.isValue(option, 'should')
    const excluded = this.isValue(option, 'must_not')
    const className = classNames[selected ? 'buttonSelected' : (excluded ? 'buttonExcluded' : 'button')]
    const onClick = selected ? this.excludeItem : (excluded ? this.removeItem : this.selectItem)
    return (
      <button key={option} className={className} onClick={onClick} value={option}>
        {option}
      </button>
    )
  }
  render () {
    return (
      <div>
        {this.props.options
          ? this.props.options.map(this.renderOption)
          : 'Loading options…'
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/search/GenericIncludeExcludePicker.js